const Transfer = () => import('@/views/Transfer')
export default [

  {
    path: '/transfer',
    component: Transfer,
    meta: { requireAuth: false }
  }
]
